import { render, staticRenderFns } from "./RankingTableWidget.vue?vue&type=template&id=bdddae60&"
import script from "./RankingTableWidget.vue?vue&type=script&lang=js&"
export * from "./RankingTableWidget.vue?vue&type=script&lang=js&"
import style0 from "./RankingTableWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports